export default from './NonPsychicReports';



// WEBPACK FOOTER //
// ./src/elements/non-psychic-reports/index.jsx